/**
 * @module Template-Home-Page-Style-2
 */

import { useEffect, useState } from "react";
import { loadScript } from "../../../globals/common-functions";
import { TypePageHome2 } from "../../@types/pageTypes";
import { getHome2Data } from "../../../api/home2-service";
import SectionHome2Slider from "../../sections/home/home2/home2-slider";
import SectionHome2About from "../../sections/home/home2/home2-about";

import SectionHome2CaseStudy from "../../sections/home/home2/home2-case-study";
import SectionHome2EnhancedServices from "../../sections/home/home2/home2-enhanced-services";
import SectionHome2Testimonials from "../../sections/home/home2/home2-testimonials";
import SectionHome2Team from "../../sections/home/home2/home2-team";
import SectionHome2FAQ from "../../sections/home/home2/home2-faq";
import SectionHome2WhatWeDo from "../../sections/home/home2/home2-what-we-do";
import SectionSharedBlogs from "../../sections/common/shared/blogs";
import SectionSharedITSolutions from "../../sections/common/shared/it-solutions";

/**
 * 
 * @returns Markup template for sample page Home2
 */
const Home2Page = () => {

    const _home2Default: TypePageHome2 = {};
    const [results, setResults] = useState(_home2Default);
    const [isFetching, setIsFetching] = useState(true);

    useEffect(() => {

        getHome2Data((response: TypePageHome2) => {
            setIsFetching(false);
            setResults(response);
            loadScript("js/custom.js")
            loadScript("js/masonry-grid.js");
            loadScript("js/navigation.js");
        })

    }, [isFetching])

    // Handle hash changes for services section
    useEffect(() => {
        const handleHashChange = () => {
            if (window.location.hash === '#services') {
                setTimeout(() => {
                    const servicesSection = document.querySelector('#services');
                    if (servicesSection) {
                        servicesSection.scrollIntoView({ 
                            behavior: 'smooth',
                            block: 'start'
                        });
                    }
                }, 500);
            }
        };

        // Check on initial load
        handleHashChange();

        // Listen for hash changes
        window.addEventListener('hashchange', handleHashChange);
        
        return () => {
            window.removeEventListener('hashchange', handleHashChange);
        };
    }, []);

    return (
        <>
            {/*SLIDER BANNER START*/}
            {
                results.slider &&
                <SectionHome2Slider
                    _slider={results.slider!} />
            }

            {/*SLIDER BANNER END*/}

            {/* About US SECTION START */}
            {
                results.about &&
                <SectionHome2About
                    _about={results.about!} />
            }
            {/* About US SECTION END */}

            {/*Enhanced Services SECTION START */}
            {
                results.services && results.technologies &&
                <SectionHome2EnhancedServices 
                _services={results.services!}
                _technologies={results.technologies!} />
            }
            {/* Enhanced Services SECTION END */}

            {/* Case Study SECTION START */}
            {
                results.caseStudy &&
                <SectionHome2CaseStudy 
                _caseStudy={results.caseStudy!} />
            }
            {/* Case Study SECTION END */}

            {/* We Are About SECTION START */}
            {
                results.whatWeDo &&
                <SectionHome2WhatWeDo 
                _whatWeDo={results.whatWeDo!} />
            }
            {/* We Are About SECTION END */}

            {/* FAQ SECTION START */}
            {
                results.faq &&
                <SectionHome2FAQ 
                _faqs={results.faq!} />
            }
            {/* FAQ SECTION END */}

            {/* OUR BLOG SECTION START */}
            {
                results.blogs &&
                <SectionSharedBlogs 
                _blogs={results.blogs!} />
            }
            {/* OUR BLOG SECTION END */}
        </>
    )
}
export default Home2Page;